import { Stack, Typography } from "@mui/material";

import { ISOStringToLocalReadableTimestamp } from "utils";

const SECTION_STYLE = {
  borderColor: "#cecdcd",
  borderWidth: "1px",
  borderStyle: "solid",
  borderRadius: 2,
  p: ".5rem",
};

interface Props {
  shipment: SupplierShipment;
}

export function SupplierShipmentStateDisplay(props: Props) {
  const { shipment } = props;

  let component = <div />;

  if (shipment?.shipment_status === "BOOKING_CANCELLED") {
    if (
      shipment.booking_cancellation !== undefined &&
      shipment.booking_cancellation !== null
    ) {
      component = (
        <Stack direction="column" sx={SECTION_STYLE}>
          <Typography>
            Booking{" "}
            <b>
              <u>cancelled</u>
            </b>{" "}
            by <b>{shipment.booking_cancellation.created_by.user.first_name}</b>{" "}
            <b>{shipment.booking_cancellation.created_by.user.last_name}</b> on{" "}
            {ISOStringToLocalReadableTimestamp(
              shipment.booking_cancellation.created_at,
            )}
          </Typography>
          <Typography>
            <b>{"Reason: "}</b>
            {shipment.booking_cancellation.reason}
          </Typography>
        </Stack>
      );
    }
  }

  if (shipment?.shipment_status === "DELIVERED") {
    if (shipment.delivery !== undefined && shipment.delivery !== null) {
      component = (
        <Stack direction="column" spacing={1} sx={SECTION_STYLE}>
          <Typography>
            Shipment marked as{" "}
            <b>
              <u>delivered</u>
            </b>{" "}
            on{" "}
            {ISOStringToLocalReadableTimestamp(shipment.delivery.delivered_at)}
          </Typography>
          <Typography>
            Marked delivered by{" "}
            <b>{shipment.delivery.created_by.user.first_name}</b>{" "}
            <b>{shipment.delivery.created_by.user.last_name}</b>
          </Typography>
          {shipment.delivery.notes != null &&
            shipment.delivery.notes !== "" && (
              <Typography>
                <b>{"Notes: "}</b>
                {shipment.delivery.notes}
              </Typography>
            )}
          <Typography variant="body2" color="text.secondary">
            Delivered status created on{" "}
            {ISOStringToLocalReadableTimestamp(shipment.delivery.created_at)}
          </Typography>
        </Stack>
      );
    }
  }

  if (shipment?.shipment_status === "PICKED_UP") {
    if (shipment.first_pickup !== undefined && shipment.first_pickup !== null) {
      component = (
        <Stack direction="column" spacing={1} sx={SECTION_STYLE}>
          <Typography>
            Shipment marked as{" "}
            <b>
              <u>picked up</u>
            </b>
            <u /> on{" "}
            {ISOStringToLocalReadableTimestamp(
              shipment.first_pickup.picked_up_at,
            )}
          </Typography>
          <Typography>
            Marked picked up by{" "}
            <b>{shipment.first_pickup.created_by.user.first_name}</b>{" "}
            <b>{shipment.first_pickup.created_by.user.last_name}</b>
          </Typography>
          {shipment.first_pickup.notes != null &&
            shipment.first_pickup.notes !== "" && (
              <Typography>
                <b>{"Notes: "}</b>
                {shipment.first_pickup.notes}
              </Typography>
            )}
          <Typography variant="body2" color="text.secondary">
            Picked up status created on{" "}
            {ISOStringToLocalReadableTimestamp(
              shipment.first_pickup.created_at,
            )}
          </Typography>
        </Stack>
      );
    }
  }

  return <Stack mt="1rem">{component}</Stack>;
}
